<template>
  <div>
    <div class="mb30">
      <button type="button"
        class="btn btnActivate"
        :class="{active: infoData.active}"
        @click="infoData.active = !infoData.active">
        {{locale.activate}}
      </button>
    </div>
    <div class="mb30">
      <p class="innerTitle setLabel">{{locale.messanger_id}}</p>
      <input type="text" class="input" v-model="infoData.messangerId">
    </div>
    <div class="mb30">
      <div class="checkbox f_medium">
        <input type="checkbox" id="fm_mainOnly" v-model="infoData.mainOnly">
        <label for="fm_mainOnly">{{locale.floating_set_main_only}}</label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Facebookmessanger',
  props: [
    'locale',
    'infoData'
  ],
  computed: {
  },
  mounted () {
    // this.init()
  },
  data () {
    return {
    }
  },
  methods: {
    init () {
      if (this.infoData) {
        this.info = {
          ...this.info,
          ...this._.cloneDeep(this.infoData)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.btn.btnActivate {
  border-color: $color-lgrey;
  background-color: $color-lgrey;
  &.active {
    border-color: $color-primary;
    background-color: $color-primary;
  }
}
</style>
